export const manufacturingDe = {
  title: 'Produktionsaufträge',
  subtitle:
    'Freigegebene Rezepturen planen, chargengenau verbrauchen und revisionssicher fertigmelden.',
  help: {
    open: 'Hilfe zu Produktionsaufträgen öffnen',
    detail: 'Hilfe zu Planung, Buchungen und Fertigmeldung öffnen',
  },
  actions: {
    new: 'Neuer Auftrag',
    plan: 'Planen',
    release: 'Freigeben',
    reserve: 'Material reservieren',
    start: 'Starten',
    pause: 'Pausieren',
    resume: 'Fortsetzen',
    reportComplete: 'Fertigmelden',
    close: 'Abschließen',
    cancel: 'Stornieren',
    issue: 'Entnehmen',
    return: 'Zurückbuchen',
    confirmStep: 'Rückmelden',
    comment: 'Kommentar',
    post: 'Buchen',
  },
  filters: {
    search: 'Nummer, Artikel oder Bedarf suchen',
    status: 'Status',
    allStatuses: 'Alle Status',
    priority: 'Priorität',
    allPriorities: 'Alle Prioritäten',
    from: 'Start ab',
    to: 'Start bis',
  },
  statuses: {
    DRAFT: 'Entwurf',
    PLANNED: 'Geplant',
    RELEASED: 'Freigegeben',
    MATERIAL_RESERVED: 'Material reserviert',
    IN_PRODUCTION: 'In Produktion',
    PAUSED: 'Pausiert',
    REPORTED_COMPLETE: 'Fertiggemeldet',
    CLOSED: 'Abgeschlossen',
    CANCELLED: 'Storniert',
  },
  priorities: { LOW: 'Niedrig', NORMAL: 'Normal', HIGH: 'Hoch', URGENT: 'Dringend' },
  columns: {
    number: 'Auftrag',
    product: 'Fertigprodukt',
    status: 'Status',
    priority: 'Priorität',
    recipe: 'Rezeptur',
    planned: 'Soll',
    produced: 'Ist-Menge',
    start: 'Start',
    updated: 'Geändert',
    position: 'Pos.',
    material: 'Material',
    reserved: 'Reserviert',
    issued: 'Entnommen',
    returned: 'Zurück',
    scrap: 'Ausschuss',
    variance: 'Abweichung',
    step: 'Arbeitsschritt',
    workCenter: 'Arbeitsplatz',
    duration: 'Dauer (min)',
    input: 'Eingabe',
    output: 'Ausgabe',
    type: 'Art',
    batch: 'Charge',
    quantity: 'Menge',
  },
  empty: 'Keine Produktionsaufträge gefunden.',
  editor: {
    newTitle: 'Produktionsauftrag anlegen',
    subtitle:
      'Der Sollbedarf wird reproduzierbar aus freigegebener Rezeptur und Arbeitsplan berechnet.',
    plan: 'Planungsgrundlage',
    planDescription:
      'Quelle, Menge, Termine, Lagerorte und Verantwortliche festlegen. Entwürfe sind optimistisch gesperrt.',
  },
  fields: {
    recipe: 'Freigegebene Rezeptur',
    routing: 'Freigegebener Arbeitsplan',
    plannedQuantity: 'Planmenge',
    unit: 'Einheit',
    priority: 'Priorität',
    salesOrder: 'Kundenauftrag',
    plannedStart: 'Geplanter Start',
    plannedEnd: 'Geplantes Ende',
    sourceWarehouse: 'Entnahmelager',
    targetWarehouse: 'Ziellager',
    internalDemand: 'Interner Bedarf',
    responsibleUsers: 'Verantwortliche Personen',
    note: 'Notiz / Begründung',
    postingType: 'Buchungsart',
    quantity: 'Menge',
    reason: 'Begründung',
    stepResult: 'Ergebnis',
    inputQuantity: 'Eingangsmenge',
    outputQuantity: 'Ausgangsmenge',
    scrapQuantity: 'Ausschussmenge',
    duration: 'Ist-Dauer (min)',
    qualityChecks: 'Pflichtprüfungen',
    producedQuantity: 'Produzierte Menge',
    batchNumber: 'Neue Chargennummer',
    bestBefore: 'Mindesthaltbarkeit',
  },
  shortage: {
    title: 'Materialfehlmenge',
    description:
      '{{count}} Materialposition(en) sind mit dem aktuellen freien Bestand nicht vollständig deckbar.',
  },
  tabs: {
    materials: 'Material & Verbrauch',
    process: 'Prozess & Qualität',
    outputs: 'Ausbringung',
    history: 'Historie & Kommentare',
    documents: 'DMS-Dokumente',
  },
  documents: { title: 'Produktionsakte' },
  summary: {
    planned: 'Planmenge',
    produced: 'Produziert',
    scrap: 'Ausschuss',
    yield: 'Ist-Ausbeute',
    plannedCost: 'Soll-Materialkosten',
    actualCost: 'Ist-Materialkosten',
  },
  materials: {
    title: 'Materialpositionen',
    description:
      'Soll, Reservierung und chargengenaue Ist-Buchungen werden getrennt und in exakten Dezimalmengen geführt.',
  },
  process: {
    title: 'Prozessrückmeldungen',
    description:
      'Arbeitsschritte, Parameter und Qualitätsprüfungen stammen aus dem freigegebenen Planungssnapshot.',
  },
  stepStatuses: {
    PENDING: 'Offen',
    IN_PROGRESS: 'In Arbeit',
    COMPLETED: 'Abgeschlossen',
    SKIPPED: 'Begründet übersprungen',
  },
  outputs: {
    title: 'Ausbringung und erzeugte Chargen',
    description: 'Fertigware, Nebenprodukte und Ausschuss aus der Fertigmeldung.',
    empty: 'Noch keine Ausbringung gebucht.',
  },
  outputTypes: { FINISHED_GOOD: 'Fertigware', BYPRODUCT: 'Nebenprodukt', SCRAP: 'Ausschuss' },
  history: {
    title: 'Unveränderliche Buchungshistorie',
    description:
      'Jede Operation besitzt Idempotenzschlüssel, Payload-Hash, Benutzer und Zeitpunkt.',
  },
  comments: {
    title: 'Kommentare',
    description: 'Append-only Hinweise in der revisionssicheren Auftragsakte.',
    empty: 'Noch keine Kommentare.',
  },
  operationTypes: {
    CREATE: 'Angelegt',
    UPDATE: 'Entwurf geändert',
    PLAN: 'Geplant',
    RELEASE: 'Freigegeben',
    RESERVE: 'Reserviert',
    ISSUE: 'Material entnommen',
    RETURN: 'Material zurückgebucht',
    START: 'Gestartet',
    PAUSE: 'Pausiert',
    RESUME: 'Fortgesetzt',
    STEP_CONFIRM: 'Schritt rückgemeldet',
    REPORT_COMPLETE: 'Fertiggemeldet',
    CLOSE: 'Abgeschlossen',
    CANCEL: 'Storniert',
    COMMENT: 'Kommentar ergänzt',
  },
  workflow: {
    plan: {
      title: 'Auftrag planen',
      description:
        'Der Planungssnapshot wird eingefroren; Strukturänderungen sind danach nicht mehr möglich.',
    },
    release: {
      title: 'Auftrag freigeben',
      description:
        'Die freigegebenen Quellen und der Sollbedarf werden verbindliche Buchungsgrundlage.',
    },
    start: {
      title: 'Produktion starten',
      description:
        'Der tatsächliche Start wird protokolliert. Entnahmen bleiben chargengenau nachvollziehbar.',
    },
    pause: {
      title: 'Produktion pausieren',
      description: 'Der Auftrag bleibt buchbar, wird aber als pausiert gekennzeichnet.',
    },
    resume: {
      title: 'Produktion fortsetzen',
      description: 'Der Auftrag wechselt zurück in die laufende Produktion.',
    },
    close: {
      title: 'Auftrag abschließen',
      description:
        'Offene Reservierungen werden freigegeben; der abgeschlossene Auftrag ist unveränderlich.',
    },
  },
  reserve: {
    title: 'Freien Bestand automatisch reservieren',
    description:
      'Die Auswahl erfolgt transaktional nach Artikelstrategie (FEFO/FIFO). Fehlmengen bleiben als Warnung sichtbar.',
  },
  materialDialog: {
    ISSUE: { title: 'Materialentnahme buchen' },
    SCRAP: { title: 'Materialausschuss buchen' },
    RETURN: { title: 'Material zurückbuchen' },
  },
  materialActions: { ISSUE: 'Entnahme', SCRAP: 'Ausschuss', RETURN: 'Rückgabe' },
  quality: { PASS: 'Bestanden', FAIL: 'Nicht bestanden', NOT_CHECKED: 'Nicht geprüft' },
  stepDialog: { title: 'Prozessschritt rückmelden' },
  report: {
    title: 'Produktion fertigmelden',
    description:
      'Die Fertigwarencharge und Bestandszugänge werden gemeinsam in einer Transaktion erzeugt.',
  },
  cancel: {
    title: 'Produktionsauftrag stornieren',
    description:
      'Eine Stornierung ist nur ohne verbleibenden Ist-Verbrauch möglich und muss begründet werden.',
  },
  comment: {
    title: 'Kommentar ergänzen',
    description: 'Der Eintrag wird unveränderlich mit Benutzer und Zeitstempel gespeichert.',
  },
  messages: {
    created: 'Produktionsauftrag angelegt.',
    saved: 'Entwurf gespeichert.',
    workflow: 'Status erfolgreich geändert.',
    reserved: 'Verfügbares Material reserviert.',
    posted: 'Materialbuchung erfolgreich.',
    stepConfirmed: 'Prozessschritt rückgemeldet.',
    completed: 'Produktion fertiggemeldet.',
    cancelled: 'Produktionsauftrag storniert.',
    commented: 'Kommentar ergänzt.',
  },
} as const;
